const logotext = ".: 929 :.";
const meta = {
  title: "Jose Montiel",
  description:
    "Graphic Designer / Web Developer / Software Engineer ... currently residing in Eagle Mountain, Utah",
};

const cloudinary_path = "https://res.cloudinary.com/dd8bzxwbc/image/upload/";

const introdata = {
  title: "I'm Jose Montiel",
  animated: {
    first: "I believe that products have to both;",
    second: "work well, and look good.",
  },
  description:
    "Fluent in responsive design, and obsessive about typography, mobile first design, and user experience",
  your_img_url: cloudinary_path + "background_bnii80.jpg",
};

const dataabout = {
  title: "A bit about myself",
  aboutme:
    "I'm a designer/developer hybrid with over 25 years experience in print/web/app development. Fluent in HTML, CSS, JS, React (JSX), responsive design, and obsessive about typography, mobile first design, and user experience. I believe that products have to both; work well and look good.",
};
const worktimeline = [
  {
    jobtitle: "OSHA / DOL ( Subcontractor: OpTech, 22nd Century, MindPetal)",
    where: "Web Developer, Sr. Web Developer, Cloud Developer",
    date: "2019-Current",
  },
  {
    jobtitle: "On Target Media Inc.",
    where: "Web Developer",
    date: "2016-2018",
  },
  {
    jobtitle: "Stratosphere Casino, Hotel & Tower",
    where: "Web Designer/Developer",
    date: "2015-2016",
  },
  {
    jobtitle: "Havas Helia",
    where: "Motion Ad Developer",
    date: "2014-2015",
  },
  {
    jobtitle: "Prosperity Alliance, LLC",
    where: "Graphic Designer/Web Developer",
    date: "2008-2014",
  },
  {
    jobtitle: "AdEmphasis/OnSite Creative Services",
    where: "Graphic Designer",
    date: "2008-2008",
  },
  {
    jobtitle: "Las Vegas Review Journal",
    where: "Senior Graphic Designer",
    date: "2005-2008",
  },
];

const skills = [
  {
    name: "Adobe CS",
    value: 90,
  },
  {
    name: "HTML/HTML5",
    value: 100,
  },
  {
    name: "CSS/CSS3",
    value: 100,
  },
  {
    name: "Responsive",
    value: 100,
  },
  {
    name: "Wordpres / Drupal",
    value: 80,
  },
  {
    name: "JS / JSX / React",
    value: 80,
  },
];

const education = [
  {
    school: "The Art Institute of Las Vegas",
    degree: "B.F.A",
    major: "Multimedia/Web Design",
  },
  {
    school: "Advanced Technologies Academy",
    degree: "Majored in Graphic Design",
    major: "Magnet Highschool",
  },
];

const dataportfolio = [
  {
    id: 1,
    category: ["webdesign", "responsive"],
    image: "49_eyemxf.png",
    bigImage: "49_nm2bap.png",
    title: "Things To Do In Las Vegas",
    link: "https://thingstodoinlasvegas.com/",
  },
  {
    id: 2,
    category: ["webdesign"],
    image: "48_edzghc.png",
    bigImage: "48_kvifzn.png",
    title: "Findlay Fiat Slider Ads",
  },
  {
    id: 3,
    category: ["webdesign", "responsive"],
    image: "46_drd7lt.png",
    bigImage: "44_asclx9.png",
    title: "Brandner Gives Back",
    link: "https://brandnergivesback.com/",
  },
  {
    id: 4,
    category: ["webdesign", "responsive"],
    image: "htl_thumb_eyz7rv.png",
    bigImage: "htl_big_j4xzex.png",
    title: "Hot Tub Liquidators",
    link: "https://hottubliquidators.com/",
  },
  {
    id: 5,
    category: ["webdesign", "responsive"],
    image: "44_sutvem.png",
    bigImage: "46_fx2lm0.png",
    title: "The Benefit",
  },
  {
    id: 6,
    category: ["webdesign", "responsive"],
    image: "43_zqwlyv.png",
    bigImage: "43_scvthk.png",
    title: "Enjoy A Bowl",
    link: "https://enjoyabowlproducts.com/",
  },
  {
    id: 7,
    category: ["webdesign", "responsive"],
    image: "42_y0znrd.png",
    bigImage: "42_afjcdf.png",
    title: "Marss Music",
  },
  {
    id: 8,
    category: ["webdesign", "responsive"],
    image: "41_wm32wp.png",
    bigImage: "41_ak9gyc.png",
    title: "Peaceful Parents",
  },
  {
    id: 9,
    category: ["webdesign", "responsive"],
    image: "40_eauitc.png",
    bigImage: "40_owhavx.png",
    title: "Valle Verde Vet : dev",
  },
  {
    id: 10,
    category: ["webdesign"],
    image: "38_idtl1t.png",
    bigImage: "38_cobkwf.png",
    title: "Top Of The World Concept 002",
  },
  {
    id: 11,
    category: ["webdesign"],
    image: "36_wjsp3i.png",
    bigImage: "36_equh0t.png",
    title: "AquariusCasinoResort.com Design/CSS updates",
  },
  {
    id: 12,
    category: ["webdesign"],
    image: "35_ixzqbo.png",
    bigImage: "35_rqd1u8.png",
    title: "StratosphereHotel.com Design/CSS updates",
  },
  {
    id: 13,
    category: ["ux", "apps"],
    image: "34_jz708z.png",
    bigImage: "34_pj2njz.png",
    title: "acePLAY Members Web App",
  },
  {
    id: 14,
    category: ["print"],
    image: "32_bvmdse.png",
    bigImage: "32_gscn4j.png",
    title: "McCalls Heartland Grill - PDF",
    link: cloudinary_path + "v1747924528/mcCalls_ztpaoy.pdf",
  },
  {
    id: 15,
    category: ["webdesign"],
    image: "20_czxbz1.png",
    bigImage: "20_b9emxi.png",
    title: "Health Hustlers: Website Mockup",
  },
  {
    id: 16,
    category: ["print"],
    image: "7_tx3hbj.png",
    bigImage: "7_tcuuct.png",
    title: "Prosperity Alliance Pamphlet",
    link: cloudinary_path + "v1748396814/prosperityPamphlet_e1vz1o.pdf",
  },
  {
    id: 17,
    category: ["print"],
    image: "5_be27xm.png",
    bigImage: "5_vaqow9.png",
    title: "Centroamerica Magazine",
    link: cloudinary_path + "v1747924528/mcCalls_ztpaoy.pdf",
  },
  {
    id: 18,
    category: ["react", "games"],
    image: "Tenzies_thumb_s05ozx.png",
    bigImage: "Tenzies_big_vq4e8d.png",
    title: "Tenzies",
    link: "k3pmfp",
  },
  {
    id: 19,
    category: ["react", "games"],
    image: "EndGame_thumb_u6y1jd.png",
    bigImage: "EndGame_big_pbnnwa.png",
    title: "End Game",
    link: "s36vtn",
  },
  {
    id: 20,
    category: ["react"],
    image: "Meme_thumb_suqnw6.png",
    bigImage: "Meme_big_nlelpi.png",
    title: "Meme Generator",
    link: "ksdndm",
  },
  {
    id: 21,
    category: ["react"],
    image: "ImgCompressor_thumb_q0tpwk.png",
    bigImage: "ImgCompressor_big_zuylba.png",
    title: "Image Compressor",
    link: "w4xvrj",
  },
  {
    id: 22,
    category: ["react"],
    image: "Emoji_thumb_rqgi1z.png",
    bigImage: "Emoji_big_uehiwv.png",
    title: "Emoji Search",
    link: "n57jxp",
  },
  {
    id: 23,
    category: ["react", "apps"],
    image: "ToDos_thumb_k9cieb.png",
    bigImage: "ToDos_big_hpbfvf.png",
    title: "ToDo List",
    link: "n38g78",
  },
  {
    id: 24,
    category: ["react"],
    image: "TravelJournal_thumb_u8wzta.png",
    bigImage: "TravelJournal_big_uyusj4.png",
    title: "Travel Journal",
    link: "xww2kh",
  },
  {
    id: 25,
    category: ["react", "apps"],
    image: "BudgetTracker_thumb_zhvqaj.png",
    bigImage: "BudgetTracker_big_et9zz1.png",
    title: "Budget Tracker",
    link: "dvf7mr",
  },
  {
    id: 26,
    category: ["react", "apps"],
    image: "Weather_thumb_xnje1a.png",
    bigImage: "Weather_big_xilqnu.png",
    title: "Weather App",
    link: "pz9s84",
  },
  {
    id: 27,
    category: ["react", "apps"],
    image: "ChefClaude_thumb_o0ami8.png",
    bigImage: "ChefClaude_big_qkxzcb.png",
    title: "Chef Claude",
    link: "5hdpg5",
  },
  {
    id: 28,
    category: ["react", "apps"],
    image: "EMS_thumb_aixnkx.png",
    bigImage: "EMS_big_gd9jxx.png",
    title: "Employee Management",
    link: "yh8k6y",
  },
  {
    id: 29,
    category: ["react"],
    image: "PassGen_thumb_w7prug.png",
    bigImage: "PassGen_big_jnrsaz.png",
    title: "Password Generator",
    link: "cy356w",
  },
  {
    id: 30,
    category: ["react"],
    image: "Movies_thumb_clhb2x.png",
    bigImage: "Movies_big_ewfqa4.png",
    title: "Movie Search",
    link: "slvm25",
  },
  {
    id: 31,
    category: ["react"],
    image: "Clocks_thumb_xuz5bm.png",
    bigImage: "Clocks_big_ph4h6x.png",
    title: "World Clocks",
    link: "t85tgy",
  },
  {
    id: 32,
    category: ["react"],
    image: "DataTable_thumb_xhlotg.png",
    bigImage: "DataTable_big_hg0itj.png",
    title: "Data Table",
    link: "cfn55h",
  },
  {
    id: 33,
    category: ["react", "responsive"],
    image: "SnapShot_thumb_v0sbgm.png",
    bigImage: "SnapShot_big_svj7n3.png",
    title: "SnapShot",
    link: "2nv93w",
  },
].map((item) => {
  const newItem = {
    ...item,
    image: cloudinary_path + item.image,
    bigImage: cloudinary_path + item.bigImage,
  };

  if (item.link) {
    newItem.link = item.link.startsWith("http")
      ? item.link
      : `https://${item.link}.csb.app/`;
  }

  return newItem;
});

const contactConfig = {
  YOUR_EMAIL: "nine2nine@yahoo.com",
  YOUR_FONE: "(702)245-0035",
  description: "Get In Touch... please feel free to send me a message.",
  YOUR_SERVICE_ID: "service_r7zmlrc",
  YOUR_TEMPLATE_ID: "template_1uzrbik",
  YOUR_USER_ID: "R42zytvhMKTrmKZ1V",
};

const socialprofils = {
  github: "https://github.com/xNINE2NINEx",
  /*facebook: "https://facebook.com",*/
  linkedin: "https://linkedin.com/in/jmontiel929",
  /*twitter: "https://twitter.com",*/
};
export {
  meta,
  dataabout,
  dataportfolio,
  worktimeline,
  skills,
  education,
  introdata,
  contactConfig,
  socialprofils,
  logotext,
};
